import routes from '@modules/fan/fan-routes';
import store from '@modules/fan/fan-store';

export default {
  routes,
  store,
};
